export enum GemLocation {
  Ampara = 'Ampara',
  Anuradhapura = 'Anuradhapura',
  Badulla = 'Badulla',
  Batticaloa = 'Batticaloa',
  Colombo = 'Colombo',
  Galle = 'Galle',
  Gampaha = 'Gampaha',
  Hambantota = 'Hambantota',
  Jaffna = 'Jaffna',
  Kalutara = 'Kalutara',
  Kandy = 'Kandy',
  Kegalle = 'Kegalle',
  Kilinochchi = 'Kilinochchi',
  Kurunegala = 'Kurunegala',
  Mannar = 'Mannar',
  Matale = 'Matale',
  Matara = 'Matara',
  Monaragala = 'Monaragala',
  Mullaitivu = 'Mullaitivu',
  NuwaraEliya = 'Nuwara Eliya',
  Polonnaruwa = 'Polonnaruwa',
  Puttalam = 'Puttalam',
  Ratnapura = 'Ratnapura',
  Trincomalee = 'Trincomalee',
  Vavuniya = 'Vavuniya',
  NA = 'N/A',
}
